import { useState } from "react";
import { Button, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CardItem from "./CardItem";
import { Translate } from "../../Enums/Tranlate";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import NotificationService from "../../../services/NotificationService";

const Notification = () => {
	const [notification, setNotification] = useState([]);
	const [hasData, setHasData] = useState(0);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.roles?.includes(data);
	const navigate = useNavigate();
	const notificationService = new NotificationService();
	const search = useSelector((state) => state.auth.search);

	return (
		<>
			<div className="d-flex justify-content-between align-items-center mb-3">
				<span
					style={{
						fontWeight: "600",
						textTransform: "capitalize",
						color: "#000",
					}}>
					{Translate[lang].notifications}
				</span>
				{isExist("add_notification") && (
					<Button
						variant="primary"
						onClick={() => {
							navigate("add-notification");
						}}>
						<i className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
						{Translate[lang].add} {Translate[lang].notification}
					</Button>
				)}
			</div>
			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>{Translate[lang].title}</strong>
									</th>
									<th>
										<strong>{Translate[lang].message}</strong>
									</th>
									<th>
										<strong>{Translate[lang].action}</strong>
									</th>
								</tr>
							</thead>

							<tbody className="table-body">
								{notification?.map((item, index) => {
									return (
										<CardItem
											index={index}
											key={index}
											item={item}
											setShouldUpdate={setShouldUpdate}
										/>
									);
								})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && !loading && <NoData />}
					<Pagination
						setData={setNotification}
						service={notificationService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
					/>
				</div>
			</div>
		</>
	);
};

export default Notification;
